import axios from "axios";
import { geoServerBaseUrl } from "./baseUrl";

export const set_value_editor = (body) => (dispatch) => {
  dispatch({
    type: "set_value_editor",
    payload: body,
  });
};

//public 1
export const get_public_folder_list =
  (language) => async (dispatch, getState) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.jwtTokenMapid,
        },
      };
      const res = await axios.get(
        geoServerBaseUrl + `/docs/get_public_folder_list?language=${language}`,
        config,
      );
      const data = res.data || {};
      dispatch({
        type: "set_value_editor",
        payload: {
          key: "parent_object",
          value: data,
        },
      });
    } catch (error) {}
  };

//public 2
export const get_public_doc_list = (language) => async (dispatch, getState) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.jwtTokenMapid,
      },
    };
    const res = await axios.get(
      geoServerBaseUrl + `/docs/get_public_doc_list?language=${language}`,
      config,
    );
    const data = res.data || [];
    dispatch({
      type: "set_value_editor",
      payload: {
        key: "blog_list",
        value: data,
      },
    });
  } catch (error) {}
};

//public 3
export const get_blog_object_by_link_public =
  (link) => async (dispatch, getState) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.jwtTokenMapid,
        },
      };
      const res = await axios.get(
        geoServerBaseUrl + `/docs/get_blog_object_by_link_public?link=${link}`,
        config,
      );
      const data = res.data || {};
      dispatch({
        type: "set_value_editor",
        payload: {
          key: "selected_blog",
          value: data,
        },
      });
    } catch (error) {}
  };
